//export const API_BASE_URL = "http://127.0.0.1:5001/" //http://localhost:5001/api
export const API_BASE_URL = window._ENV_.REACT_APP_API_BASE_URL
export const CALL_API = "middleware@CALL_API"

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE"
}
